var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { SortDirection, SortAction } from './types';
import SortsMixin from './mixin/sorts';
import FilterCollectionMixin from './mixin/filter-collection';
import ChoiceFilter from './filter/choice.vue';
import DateTimeFilter from './filter/datetime.vue';
import { format } from '@core/helper/string';
var HeaderCell = /** @class */ (function (_super) {
    __extends(HeaderCell, _super);
    function HeaderCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.SortAction = SortAction;
        _this.SortDirection = SortDirection;
        _this.sortAction = null;
        _this.isLoading = false;
        _this.showFilters = false;
        return _this;
    }
    Object.defineProperty(HeaderCell.prototype, "nextSortDirection", {
        get: function () {
            switch (this.sortDirection) {
                case SortDirection.None:
                case SortDirection.Desc:
                    return SortDirection.Asc;
                case SortDirection.Asc:
                    return SortDirection.Desc;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HeaderCell.prototype, "sortDirection", {
        get: function () {
            return this.resolveSortDirection(this.field);
        },
        enumerable: false,
        configurable: true
    });
    HeaderCell.prototype.geDisplaySortDirection = function (direction) {
        switch (direction) {
            case SortDirection.Asc:
                return gettext('Ascending');
            case SortDirection.Desc:
                return gettext('Descending');
            case SortDirection.None:
                return gettext('N/A');
        }
    };
    Object.defineProperty(HeaderCell.prototype, "sortDirectionDisplay", {
        get: function () {
            return this.geDisplaySortDirection(this.sortDirection);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HeaderCell.prototype, "nextSortDirectionDisplay", {
        get: function () {
            return this.geDisplaySortDirection(this.nextSortDirection);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HeaderCell.prototype, "sortTooltip", {
        get: function () {
            return format(gettext('Sort by this column (current: {current_sort})'), { current_sort: this.sortDirectionDisplay }, false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HeaderCell.prototype, "clearSortTooltip", {
        get: function () {
            return gettext('Remove this column from sort');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HeaderCell.prototype, "filtersTooltip", {
        get: function () {
            return gettext('Filter by this column');
        },
        enumerable: false,
        configurable: true
    });
    HeaderCell.prototype.data = function () {
        return {};
    };
    HeaderCell.prototype.mounted = function () {
        document.body.addEventListener('click', this.onBodyClick);
    };
    HeaderCell.prototype.destroyed = function () {
        document.body.removeEventListener('click', this.onBodyClick);
    };
    HeaderCell.prototype.onBodyClick = function (e) {
        var target = e.target;
        if (target != this.$el && !this.$el.contains(target)) {
            this.showFilters = false;
        }
    };
    HeaderCell.prototype.sort = function (e) {
        var _this = this;
        if (!this.field.is_sortable || this.isLoading || this.isTableLoading) {
            return;
        }
        var target = e.target;
        var RuleKind;
        (function (RuleKind) {
            RuleKind[RuleKind["Allow"] = 0] = "Allow";
            RuleKind[RuleKind["Ignore"] = 1] = "Ignore";
        })(RuleKind || (RuleKind = {}));
        // Configuration which defines what elements are allowed to trigger sort after click
        // strict: Only check the el, not its children (el.contains)
        // kind: Type of rule. Defaults to Allow.
        var rules = [
            { el: this.$el, strict: true },
            { el: this.$refs.fieldLabel },
            { el: this.$refs.sortButton },
            { el: this.$refs.clearSortButton, kind: RuleKind.Ignore }
        ];
        var validClickSource = false;
        for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
            var rule = rules_1[_i];
            // Vue elements can be null
            if (rule.el == null) {
                continue;
            }
            var kind = rule.kind != null ? rule.kind : RuleKind.Allow;
            // If the target is directly an allowed click source OR
            // rule is deep and the rule el contains the target
            if (target == rule.el || (!rule.strict && rule.el.contains(target))) {
                // Result is the kind type of the rule
                validClickSource = kind === RuleKind.Allow;
                // Ignore overrides Allow
                if (!validClickSource) {
                    break;
                }
            }
        }
        if (!validClickSource) {
            return;
        }
        this.sortAction = SortAction.Sort;
        this.isLoading = true;
        this.$emit('sort', this.field, this.nextSortDirection, function () {
            _this.isLoading = false;
            _this.sortAction = null;
        });
    };
    HeaderCell.prototype.removeSort = function () {
        var _this = this;
        this.sortAction = SortAction.Remove;
        this.isLoading = true;
        this.$emit('sort', this.field, SortDirection.None, function () {
            _this.isLoading = false;
            _this.sortAction = null;
        });
    };
    HeaderCell.prototype.onFilter = function (query, callback) {
        var _this = this;
        this.$emit('filter', this.field, query, function () {
            callback();
            _this.showFilters = false;
        });
    };
    __decorate([
        Prop({ type: Object })
    ], HeaderCell.prototype, "isEnabled", void 0);
    __decorate([
        Prop({ type: String })
    ], HeaderCell.prototype, "prefix", void 0);
    __decorate([
        Prop({ type: Object })
    ], HeaderCell.prototype, "field", void 0);
    __decorate([
        Prop({ type: Number })
    ], HeaderCell.prototype, "index", void 0);
    __decorate([
        Prop({ type: Array })
    ], HeaderCell.prototype, "filters", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], HeaderCell.prototype, "isTableLoading", void 0);
    HeaderCell = __decorate([
        Component({
            components: { ChoiceFilter: ChoiceFilter, DateTimeFilter: DateTimeFilter }
        })
    ], HeaderCell);
    return HeaderCell;
}(Mixins(FilterCollectionMixin, SortsMixin)));
export default HeaderCell;
